
export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return
  const { $supabase } = useNuxtApp()
  const session = await $supabase.auth.getSession()
  
  if (!session.data.session) {
    // Save the intended destination for post-login redirect
    const redirect = encodeURIComponent(to.fullPath)
    return navigateTo(`/login?redirect=${redirect}`)
  }
}) 